import { render, staticRenderFns } from "./classicCustom.vue?vue&type=template&id=6064240a&scoped=true&"
import script from "./classicCustom.vue?vue&type=script&lang=js&"
export * from "./classicCustom.vue?vue&type=script&lang=js&"
import style0 from "./classicCustom.vue?vue&type=style&index=0&id=6064240a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064240a",
  null
  
)

export default component.exports